export const uploadFileToS3Bucket = (s3Url: string, fileObj: File) => {
  return fetch(s3Url, {
    method: "PUT",
    body: fileObj,
    mode: "cors"
  });
};
